import React from "react";
//
import { Paper, Typography } from "@material-ui/core";
import InfoIcon from '@material-ui/icons/Info';

const styles = {
  footer: {
    height: 40,
    paddingTop: 15,
    paddingLeft: 80,
    display: "flex",
  },
};

export const Footer = () => {
  return (
    <Paper style={styles.footer}>
       <InfoIcon />
      <Typography variant="body1" color="inherit">
        This website is for educational purposes and please consult your physician for suggestions.
      </Typography>
    </Paper>
  );
};
 